import axios from 'axios';

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Dynamic fallbacks to avoid baking in localhost into live builds
export const BASE_URL = isLocal 
  ? (process.env.REACT_APP_BASE_URL) 
  : (process.env.REACT_APP_BASE_URL || window.location.origin);

export const API_URL = isLocal 
  ? (process.env.REACT_APP_API_URL) 
  : (process.env.REACT_APP_API_URL || `${window.location.origin}/api`);


const api = axios.create({
  baseURL: API_URL,
  timeout: 15000, 
});

export const formatFileUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    if (url.startsWith('http')) return url;
    // Only prepend BASE_URL for uploaded files
    if (url.startsWith('/uploads')) {
        return `${BASE_URL}${url}`;
    }
    // Return relative paths for public assets (like /assets/...)
    return url;
};

export default api;
